module.exports = __webpack_public_path__ + "static/media/CEDAPP-CRM.9ceac4e2.png";